import React from "react";
import {
  Modal,
  Box,
  Text,
  BlockStack,
  Card,
  Divider,
  InlineGrid,
  Link,
} from "@shopify/polaris";
import { QRCodeSVG } from "qrcode.react";

const QRCodeModal = ({ 
  isOpen, 
  onClose, 
  shareUrl, 
  customerName, 
  customerEmail, 
  opportunityName 
}) => {

  if (!isOpen) return null;

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="Share Client Portal"
      size="large"
    >
      <Modal.Section>
        <InlineGrid columns={{xs: 1, md: 2}} gap={{xs: "300", md: "400"}}>
          <Card>
            <Box padding={{xs: "400", md: "500"}}>
              <BlockStack gap={{xs: "400", md: "500"}}>
                <Text variant="headingMd" as="h3">
                  Customer Information
                </Text>
                <Divider />
                
                <BlockStack gap="400">
                  <Box paddingBlockEnd="200">
                    <Text variant="bodyMd" fontWeight="semibold" as="p" color="text">
                      Opportunity
                    </Text>
                    <Box paddingBlockStart="100">
                      <Text variant="bodyMd" as="p" color="subdued">
                        {opportunityName || 'N/A'}
                      </Text>
                    </Box>
                  </Box>
                  
                  <Box paddingBlockEnd="200">
                    <Text variant="bodyMd" fontWeight="semibold" as="p" color="text">
                      Customer Name
                    </Text>
                    <Box paddingBlockStart="100">
                      <Text variant="bodyMd" as="p" color="subdued">
                        {customerName || 'N/A'}
                      </Text>
                    </Box>
                  </Box>
                  
                  <Box paddingBlockEnd="200">
                    <Text variant="bodyMd" fontWeight="semibold" as="p" color="text">
                      Email
                    </Text>
                    <Box paddingBlockStart="100">
                      <Text variant="bodyMd" as="p" color="subdued">
                        {customerEmail || 'N/A'}
                      </Text>
                    </Box>
                  </Box>
                  
                  <Box paddingBlockEnd="200">
                    <Text variant="bodyMd" fontWeight="semibold" as="p" color="text">
                      Portal URL
                    </Text>
                    <Box paddingBlockStart="100">
                      <Link url={shareUrl} external>
                        {shareUrl}
                      </Link>
                    </Box>
                  </Box>
                </BlockStack>
              </BlockStack>
            </Box>
          </Card>

          <Card>
            <Box padding={{xs: "400", md: "500"}}>
              <BlockStack gap={{xs: "400", md: "500"}} align="center">
                <Text variant="headingMd" as="h3">
                  QR Code
                </Text>
                <Divider />
                
                <Box paddingBlockStart="200" paddingBlockEnd="200">
                  <Box 
                    padding="500"
                    background="surface-neutral-subdued"
                    borderRadius="300"
                  >
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <QRCodeSVG
                        value={shareUrl}
                        size={280}
                        bgColor="#FFFFFF"
                        fgColor="#000000"
                        level="M"
                        includeMargin={true}
                        style={{ 
                          display: 'block',
                          width: '100%',
                          maxWidth: '280px',
                          height: 'auto'
                        }}
                      />
                    </div>
                  </Box>
                </Box>
                
                <Text variant="bodyMd" as="p" alignment="center" color="subdued">
                  Scan with your phone to open the client portal
                </Text>
              </BlockStack>
            </Box>
          </Card>
        </InlineGrid>
      </Modal.Section>
    </Modal>
  );
};

export default QRCodeModal;
